var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpensee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256px",
    height: "256px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M 111.5,-0.5 C 122.167,-0.5 132.833,-0.5 143.5,-0.5C 197.548,8.7041 233.382,39.3708 251,91.5C 252.715,98.2585 254.215,104.925 255.5,111.5C 255.5,122.167 255.5,132.833 255.5,143.5C 246.296,197.548 215.629,233.382 163.5,251C 156.741,252.715 150.075,254.215 143.5,255.5C 132.833,255.5 122.167,255.5 111.5,255.5C 57.4517,246.296 21.6184,215.629 4,163.5C 2.28494,156.741 0.784944,150.075 -0.5,143.5C -0.5,132.833 -0.5,122.167 -0.5,111.5C 8.7041,57.4517 39.3708,21.6184 91.5,4C 98.2585,2.28494 104.925,0.784944 111.5,-0.5 Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#fff",
    d: "M 109.5,37.5 C 145.982,45.8056 171.816,67.1389 187,101.5C 194.926,120.659 198.093,140.492 196.5,161C 148.929,161.83 101.429,161.664 54,160.5C 53.3828,159.551 53.5494,158.718 54.5,158C 67.9487,150.885 78.4487,140.718 86,127.5C 97.4614,107.575 106.461,86.5749 113,64.5C 113.576,61.8758 114.91,61.2092 117,62.5C 117.333,90.5 117.667,118.5 118,146.5C 125.379,123.328 127.713,99.6616 125,75.5C 123.74,69.7195 122.073,64.0529 120,58.5C 116.452,51.4048 112.952,44.4048 109.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fff",
    d: "M 41.5,173.5 C 98.5,173.5 155.5,173.5 212.5,173.5C 211.861,178.264 209.528,182.097 205.5,185C 200.058,189.054 194.058,192.054 187.5,194C 157.6,201.156 127.266,204.989 96.5,205.5C 73.7336,205.034 55.5669,195.701 42,177.5C 41.51,176.207 41.3433,174.873 41.5,173.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpensee);
export default __webpack_public_path__ + "static/media/opensee.8ab61e0c74e81a8eb19fe1ad66c493c0.svg";
export { ForwardRef as ReactComponent };